<template>
    <el-drawer :wrapperClosable="false" :title="title" :visible.sync="dialogVisible" size="50%" direction="rtl"
      :before-close="handleClose">
  
      <div class="demo-drawer__content" ref="drawerContent">
        <el-steps style="margin: 0 20px;" :active="activeStep" finish-status="success" simple>
            <el-step title="上传内容"></el-step>
            <el-step title="二次确认"></el-step>
            <el-step title="添加完成"></el-step>
        </el-steps>

        <div v-if="activeStep == 0" >
            <div class="upInfo" style="margin-bottom: 20px;">上传格式：以<span>第n章/第n话</span>来区分章节及内容</div>
            <el-form :model="addForm" ref="ruleForm0" v-loading="loading">
                <!-- <el-form-item label="上传方式" prop="upType" :label-width="formLabelWidth">
                    <el-radio-group v-model="addForm.upType">
                        <el-radio :label="1">文件上传</el-radio>
                        <el-radio :label="2">文字上传</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <!-- <el-form-item label="选择文件" prop="fileLists" :label-width="formLabelWidth">
                    <el-upload 
                        ref="upload" 
                        class="upload-demo" 
                        drag 
                        :limit="1"
                        accept=".txt"
                        :file-list="addForm.fileLists" 
                        :auto-upload="false" 
                        action=""
                        :multiple="false"
                        :http-request="httpRequest" 
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或<span>点击上传</span>
                            <div style="line-height: 1;">只能上传 Txt 文件</div>
                        </div>
                    </el-upload>
                </el-form-item> -->
                <el-form-item label="小说内容" prop="content" :label-width="formLabelWidth"
                    :rules="[ { required: true, message: '请输入小说内容', trigger: 'blur' } ]"
                >
                    <el-input v-model="addForm.content" type="textarea" :autosize="{ minRows: 24, maxRows: 100000}" placeholder="请输入小说内容" clearable style="width: 90%;"></el-input>
                </el-form-item>
            </el-form>
        </div>

        <template v-if="activeStep == 1">
            <div class="upInfo">提示：提交时，当章节序号和已上传章节相同，将会进行覆盖！</div>
            <div class="total_txt"><div class="icon_jiantou"></div>本次共识别到<span>{{ upTotal }}</span>章</div>
            <el-form :model="addFormBack" ref="ruleFormBack" v-loading="loading">
                <el-form-item label="" prop="chaptertList">
                    <!-- <el-button class="mb20" size="small" @click="handleAddItems">+ 添加章节</el-button> -->
                    <div v-for="(item, i) in addFormBack.chaptertList" :key="i">
                        <div v-if="i != 0" class="item_line"></div>
                        <el-form-item class="mb20" label="章节序号" :prop="'chaptertList.'+i + '.index'" :label-width="formLabelWidth">
                            <el-input v-model="item.index" placeholder="请输入章节序号" clearable disabled style="width: 80%;"
                            oninput="value = value.replace(/[^\d]/g, '')"
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="mb20" label="章节名称" :prop="'chaptertList.'+i + '.title'" :label-width="formLabelWidth"
                            :rules="[{ required: true, message: '', trigger: ['blur','change'],validator: validateLength20 }]"
                        >
                            <div style="display: flex;">
                                <el-input v-model="item.title" placeholder="请输入章节名称" clearable style="width: 80%;"></el-input>
                                <!-- 删除按钮 -->
                                <!-- <img @click="handleDelItems(i)" class="PUB_form_btn" src="@/assets/btn/sc.png" alt=""> -->
                            </div>
                        </el-form-item>
                        <el-form-item class="mb20" label="章节内容" :prop="'chaptertList.'+i + '.content'" :label-width="formLabelWidth"
                            :rules="[{ required: true, message: '请输入章节内容', trigger: 'blur'}]"
                            oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/(\.\d{2})\d+/g, '$1')"
                        >
                            <el-input v-model="item.content" type="textarea" placeholder="请输入章节内容"  style="width: 80%;" autosize show-word-limit></el-input>
                        </el-form-item>
                    </div>
                </el-form-item>
            </el-form>
        </template>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">{{ activeStep == 0 ? '取消' : '返回上一步'}}</el-button>
        <el-button type="primary" @click="addPush" :loading="loading">{{ activeStep == 0 ? '下一步' : '提 交'}}</el-button>
      </div>
    </el-drawer>
  </template>
  
  <script>
  import {KsNovalManagement} from "@/api/ksNovalManagement";
  import { processErrors } from "@/utils/errorHandler";
  import SelectChecked from '@/components/Select/SelectChecked'
  const api = KsNovalManagement();
  
  export default {
    props: ['dialogVisible', "nid"],
    components: {
      SelectChecked
    },
    data() {
      return {
        activeStep: 0,
        formLabelWidth: "140px",
        title: "批量新增",
        addForm: {
            // upType: 1,
            content: '',
            // fileLists: [],
        },

        addFormBack:{
            chaptertList:[],
        },
        upTotal:0,


        loading: false,
      };
    },
    mounted() {
      
    },
    methods: {
        validateLength20 (rule, value, callback) {
            if(!value){
                callback(new Error('请输名称'));
            } else if(value.length > 20){
                callback(new Error('名称不能超过20个字'));
            } else {
                callback();
            }
        },
        handleClose(done) {
            this.$refs['ruleForm0'] && this.$refs['ruleForm0'].resetFields();
            this.$refs['ruleFormBack'] && this.$refs['ruleFormBack'].resetFields();
            this.$emit('NoneDlog')
        },
        AddNone() {
            this.scrollToPosition()
            if(this.activeStep == 0){
                this.addForm = {
                    content: '',
                }
                this.addFormBack = {
                    chaptertList:[],
                }
                this.handleClose()
            }else{
                this.activeStep --
                this.addFormBack = {
                    chaptertList:[],
                }
                this.$refs.ruleFormBack.resetFields();
            }
        },
    
        addPush() {
            this.scrollToPosition()
            if(this.activeStep == 0){
                this.$refs['ruleForm0'].validate((valid) => {
                if (valid) {
                    this.loading = true; 
                    let query = {
                        novel_id: this.nid,
                    ...this.addForm
                    }
        
                    api.ApiChapterBatchImport(query).then(res => {
                    if (res.code == 0) {
                        this.activeStep = 1;
                        this.addFormBack.chaptertList = res.data.list
                        this.upTotal = res.data.count
                        this.scrollToPosition()
                    } else {
                        processErrors(res);
                    }
                    })
                    this.loading = false;
                } else {
        
                    return false;
                }
                });
            }else if (this.activeStep == 1) {
                this.$refs['ruleFormBack'].validate((valid) => {
                if (valid) {
                    this.loading = true; 
                    let query = {
                        data: this.addFormBack.chaptertList
                    }
        
                    api.ApiChapterBatchImportSave(query).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '批量添加成功',
                            type: 'success'
                        });
                        this.$emit('AddOk');
                    } else {
                        processErrors(res);
                    }
                    })
                    this.loading = false;
                } else {
                    return false;
                }
                });
            }
        },
      // 添加滚动到指定位置的方法
        scrollToPosition() {
            this.$nextTick(() => {
                const drawerContent = this.$refs.drawerContent
                if (drawerContent) {
                    drawerContent.scrollTop = 0;
                }
            });
        },
    //   handleAddItems() {
    //     this.addFormBack.chaptertList.push({ count: '', price: '' });
    //   },
      
    //   handleDelItems(index) {
    //     this.addFormBack.chaptertList.splice(index, 1);
    //   },
    },
  }
  </script>
  <style lang='scss' scoped>
    .upInfo{
        margin: 2px 20px 0;
        background-color: #f5f7fa;
        color: #707070;
        padding: 3px 20px;
        span{
            font-weight: bold;
            margin: 0 2px;
        }
    }
    .total_txt{
        margin: 2px 20px 20px;
        background-color: #f5f7fa;
        color: #707070;
        padding: 3px 20px;
        span{
            color: #dd3c3c;
            font-weight: bold;
            margin: 0 2px;
        }
    }

  .demo-drawer__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px;
    text-align: center;
  }
  
  .demo-drawer__footer .el-button {
    //flex: 1; /* 让按钮平分容器宽度 */
    width: 320px;
    /* 设置按钮宽度为120px */
  }
  
  .demo-drawer__content {
    height: calc(100% - 80px);
    /* 给内容区域设置高度,留出按钮区域 */
    overflow-y: auto;
    /* 添加垂直滚动条 */
    margin-top: 20px;
    overflow-x: hidden;
  }
  
  ::v-deep .el-drawer__close-btn {
    font-size: 30px;
    font-weight: bold;
  }
  
  .item_line{
    width: 80%;
    border-top: 1px solid #f7f6f6;
    margin: 10px 0;
  }

  </style>